import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  IconButton,
  Tooltip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

const initialTickets = [
  {
    sno: 1,
    loginId: 'USER001',
    name: 'John Doe',
    subject: 'Account Issue',
    query: 'Unable to access my account after password reset - RESOLVED',
  },
  {
    sno: 2,
    loginId: 'USER002',
    name: 'Jane Smith',
    subject: 'Payment Problem',
    query: 'Payment failed but amount deducted from bank - REFUND PROCESSED',
  },
  {
    sno: 3,
    loginId: 'USER003',
    name: 'Mike Johnson',
    subject: 'Technical Support',
    query: 'Website not loading properly on mobile device - FIXED',
  },
];

const CloseTickets = () => {
  const [tickets, setTickets] = useState(initialTickets);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleViewTicket = (ticket) => {
    alert(`Viewing closed ticket for ${ticket.name}\nSubject: ${ticket.subject}\nQuery: ${ticket.query}`);
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Heading Section */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Close Tickets
        </Typography>
      </Box>

      {/* Table Details Section */}
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Closed Support Tickets
        </Typography>
        <Typography variant="body2" color="primary" sx={{ mb: 3, fontWeight: 'bold' }}>
          Total Records: {tickets.length}
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Login ID</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Subject</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Query</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'primary.main' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((ticket, idx) => (
                  <TableRow
                    key={ticket.sno}
                    sx={{
                      '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                      '&:hover': { backgroundColor: '#e3f2fd' }
                    }}
                  >
                    <TableCell>{ticket.sno}</TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'primary.main' }}>
                        {ticket.loginId}
                      </Typography>
                    </TableCell>
                    <TableCell>{ticket.name}</TableCell>
                    <TableCell>{ticket.subject}</TableCell>
                    <TableCell>
                      <Typography variant="body2" sx={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {ticket.query}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Tooltip title="View Ticket">
                        <IconButton
                          color="success"
                          onClick={() => handleViewTicket(ticket)}
                          sx={{ 
                            '&:hover': { 
                              backgroundColor: 'success.light',
                              color: 'white' 
                            }
                          }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={tickets.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          sx={{ mt: 2 }}
        />
      </Paper>
    </Box>
  );
};

export default CloseTickets;